module.exports = __webpack_public_path__ + "static/media/awards_3.8a948112.jpg";